// Note this file should be loaded after the <xsl:call-template name="tdi-js"/>; default NOT loaded.

//tooltips.init(); // enables tooltip support for footnotes and termrefs